import {
  HomeWithNoTopicsQuery,
  HomeWithNoTopicsQueryVariables,
} from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import {
  BrowseGrid,
  CurvedWrapper,
  FeaturedCategoriesHomePage,
  FeaturedTeacherRow,
  HomeQuery_WithNoTopics,
  MagnetPagesCarousel,
  useContentfulHomePage2Query,
  useMagnetPageQuery,
  useSubjectKeywordLinksData,
} from "@outschool/ui-components-website";
import { Loading } from "@outschool/ui-legacy-component-library";
import React from "react";

function useHomeWithNoTopicsQuery() {
  return useQueryWithPreviousData<
    HomeWithNoTopicsQuery,
    HomeWithNoTopicsQueryVariables
  >(HomeQuery_WithNoTopics, {
    context: { doNotRetry: true },
  });
}

export function MainPageBelowTheFold() {
  const { t } = useTranslation("client\\routes\\NewUserHome");
  const { data } = useHomeWithNoTopicsQuery();
  const { loading: magnetLoading, articles: magnetArticles } =
    useMagnetPageQuery({ id: "loggedout-homepage" });
  const {
    error: contentfulHomePageError,
    loading: contentfulHomePageLoading,
    items: contentfulHomePageItems,
  } = useContentfulHomePage2Query();

  const subjectKeywordLinksData = useSubjectKeywordLinksData();

  const popularTeachers = data?.featured?.popularTeachers;

  return (
    <>
      {contentfulHomePageError ? (
        <></>
      ) : contentfulHomePageLoading ? (
        <Loading />
      ) : (
        <CurvedWrapper>
          <FeaturedCategoriesHomePage
            items={contentfulHomePageItems}
            isSSR={true}
          />
        </CurvedWrapper>
      )}

      <FeaturedTeacherRow
        teachers={popularTeachers || []}
        title={t("10,000+ experienced teachers")}
      />
      {magnetLoading ? (
        <Loading />
      ) : (
        <MagnetPagesCarousel
          articles={magnetArticles}
          carouselSx={{
            maxWidth: "100%",
          }}
        />
      )}
      <BrowseGrid
        title={t("Classes by subject")}
        showTopBoxes={false}
        subjectKeywordLinksData={subjectKeywordLinksData}
      />
    </>
  );
}
